import { isValidSelectorString } from '@/utils/validations/selector.validation';
import { z } from 'zod';
import { ExtendedCircuitDaysSchema } from './CircuitDaysFormData';
import { ChildAgesSchema } from '../benefits/hotel/HotelFormData';
import { MarginRateSchema } from '../common/margin-rate.schema';

const CircuitCountryCurrencySchema = z.object({
  country: isValidSelectorString('Le pays est requis'),
  currency: isValidSelectorString('La devise est requise'),
});

const CircuitAdditionalParagraphSchema = z.object({
  title: z.string(),
  content: z.string().optional(),
});

export const CircuitSchema = ExtendedCircuitDaysSchema.extend(
  ChildAgesSchema.shape,
).extend({
  name: z.string({ message: 'Le nom est requis' }),
  remarks: z.string().optional(),
  countries: z.array(CircuitCountryCurrencySchema).min(1),
  marginRate: MarginRateSchema.optional(),
  nbDays: z.coerce
    .number({ message: 'Le nombre de jours est requis' })
    .min(1, { message: 'Le nombre de jours est requis' }),
  nbNights: z.coerce.number().min(0).optional(),
  nbParticipants: z.coerce
    .number({ message: 'Le nombre de participants est requis' })
    .min(1, { message: 'Le nombre de participants est requis' }),
  nbAdolescents: z.coerce.number().min(0).optional(),
  nbChildren: z.coerce.number().min(0).optional(),
  mainImage: z.union([z.instanceof(Blob), z.string(), z.null()]).optional(),
  images: z.array(z.union([z.instanceof(Blob), z.string()])),
  summary: z.string().optional(),
  importantPoints: z.string().optional(),
  additionalParagraphs: z.array(CircuitAdditionalParagraphSchema).max(2),
  priceIncludes: z.string().optional(),
  priceExcludes: z.string().optional(),
  modificationsConditions: z.string().optional(),
  cancellationConditions: z.string().optional(),
});

export type CircuitFormData = z.infer<typeof CircuitSchema>;
